export const conversation = {
  data: [
    {
      id: '5f3149090131ff00246208ec',
      participants: [
        {
          id: 248,
          email: 'test+prov.com',
          userType: 'provider-admin',
          timezone: null,
          isActive: true,
          patientId: null,
          fullName: 'Test Prov',
          firstName: 'test',
          lastName: 'Prov',
          gender: null,
          birthDate: null,
          address: null,
          city: null,
          userId: 248,
          addressLine1: null,
          addressLine2: null,
          mobilePhone: '1234567897',
          homePhone: null,
          extension: null,
          termId: 1,
          accountInfoStatus: 1,
          createdAt: '2020-07-06T09:12:48.232Z',
          updatedAt: '2021-05-07T13:36:34.748Z',
          createdBy: null,
          updatedBy: 20,
          countryId: null,
          stateId: 2,
          zipCodeId: null,
        },
        {
          id: 18,
          email: 'fred_m@patient.com',
          userType: 'patient',
          timezone: 'America/Los_Angeles',
          isActive: true,
          patientId: 110,
          fullName: 'Freddie Mercury',
          firstName: 'Freddie',
          lastName: 'Mercury',
          gender: 1,
          birthDate: '1946-09-05',
          address: null,
          city: 'city',
          userId: 18,
          addressLine1: 'line123',
          addressLine2: 'line 2',
          mobilePhone: '580',
          homePhone: '25',
          extension: null,
          termId: 1,
          accountInfoStatus: 3,
          createdAt: '2020-04-21T15:02:57.168Z',
          updatedAt: '2021-04-29T09:05:32.500Z',
          createdBy: null,
          updatedBy: 18,
          countryId: 1,
          stateId: 33,
          zipCodeId: 25485,
        },
      ],
      date: '2021-04-27T08:10:36.045Z',
      messages: {
        data: [
          {
            _id: '6087c6fb7c19990027029c5f',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: true,
            payload: null,
            message: '.',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-27T08:10:35.978Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '60821a745e30ea00281e4f9e',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: true,
            payload: null,
            message: 'dsada<br />',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 18,
            createdAt: '2021-04-23T00:53:08.031Z',
            updatedAt: '2021-04-27T08:10:23.879Z',
            __v: 0,
            senderInfo: {
              firstName: 'Freddie',
              lastName: 'Mercury',
              gender: 1,
              birthDate: '1946-09-05',
              address: null,
              city: 'city',
              userId: 18,
              addressLine1: 'line123',
              addressLine2: 'line 2',
              mobilePhone: '580',
              homePhone: '25',
              extension: null,
              termId: 1,
              accountInfoStatus: 3,
              createdAt: '2020-04-21T15:02:57.168Z',
              updatedAt: '2021-04-29T09:05:32.500Z',
              createdBy: null,
              updatedBy: 18,
              countryId: 1,
              stateId: 33,
              zipCodeId: 25485,
              id: 18,
              email: 'fred_m@patient.com',
              type: 'patient',
              timezone: 'America/Los_Angeles',
              fullName: 'Freddie Mercury',
            },
          },
          {
            _id: '60817478dc65c0002dc65071',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: true,
            isNotified: false,
            payload: {
              conferenceId: '5f341e33deddf3001d00af99',
            },
            message: 'Click to join the virtual visit',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-22T13:04:56.747Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '60816100dc65c0002dc64e4b',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: true,
            payload: null,
            message: 'I am Good.Any Help?Thank You',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-22T11:41:52.629Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '608061010c38af0029e70b3d',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: true,
            isNotified: false,
            payload: {
              conferenceId: '5f341e33deddf3001d00af99',
            },
            message: 'Click to join the virtual visit',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T17:29:37.878Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '60805f8a0c38af0029e70b0c',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: false,
            payload: null,
            message: 'I am Good.Any Help?Thank You',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T17:23:22.507Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '608055980c38af0029e709e3',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: true,
            isNotified: true,
            payload: {
              conferenceId: '5f341e33deddf3001d00af99',
            },
            message: 'Click to join the virtual visit',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T16:40:56.100Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '608054090c38af0029e709bc',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: true,
            payload: null,
            message: 'I am Good.Any Help?Thank You',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T16:34:17.721Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '60801b9bdc4b3f00278a87be',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: true,
            isNotified: true,
            payload: {
              conferenceId: '5f341e33deddf3001d00af99',
            },
            message: 'Click to join the virtual visit',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T12:33:31.136Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
          {
            _id: '60801a1adc4b3f00278a8785',
            attachments: [],
            isRead: {
              18: true,
              20: true,
            },
            isArchived: false,
            isVideoCall: false,
            isNotified: true,
            payload: null,
            message: 'I am Good.Any Help?Thank You',
            conversationId: '5f3149090131ff00246208ec',
            senderId: 20,
            createdAt: '2021-04-21T12:27:06.121Z',
            updatedAt: '2021-04-27T09:18:23.801Z',
            __v: 0,
            senderInfo: {
              firstName: 'Alice',
              lastName: 'in Chains',
              gender: null,
              birthDate: null,
              address: null,
              city: null,
              userId: 20,
              addressLine1: null,
              addressLine2: null,
              mobilePhone: '1234567897',
              homePhone: null,
              extension: null,
              termId: 1,
              accountInfoStatus: 1,
              createdAt: '2020-07-06T09:12:48.232Z',
              updatedAt: '2021-05-07T13:36:34.748Z',
              createdBy: null,
              updatedBy: 20,
              countryId: null,
              stateId: 2,
              zipCodeId: null,
              id: 20,
              email: 'ann+16@tidepoollabs.com',
              type: 'provider-admin',
              timezone: null,
              fullName: 'Alice in Chains',
            },
          },
        ],
        next: 'eyIkb2lkIjoiNjA4MDFhMWFkYzRiM2YwMDI3OGE4Nzg1In0',
        hasNext: true,
        previous: 'eyIkb2lkIjoiNjA4N2M2ZmI3YzE5OTkwMDI3MDI5YzVmIn0',
        hasPrevious: false,
        conversationId: '5f3149090131ff00246208ec',
      },
    },
  ],
};
